















































































































import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';

import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';

import { fetchMantenedorTipoUbicacion } from './fetchMantenedorTipoUbicacion';
import { getDate } from './helpers/getDate';
import { getUserID } from './helpers/getUserId';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    FormFieldsContainer,
    'app-confirmacion': Confirmation,
  },
})
export default class ModalViewTipoUbicacion extends Vue {
  @Prop({ default: true, type: Boolean }) show: boolean;
  @Prop({ default: {}, type: Object }) data: any;
  @Prop({ default: false, type: Boolean }) anulado: boolean;

  readonly funcionalidad: Funcionalidades = Funcionalidades.TipoUbicacion;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  previousList: any[] = [];
  listaUsers: any[] = [];
  listaUsersSave: any[] = [];
  checkAllPatent: boolean = false;
  invalidate: boolean = false;
  dialogPopUp: boolean = false;
  messageError: string = '';
  opciones: any[] = ['ACTIVO', 'INACTIVO'];

  formFields: FormFieldDefMap = {
    tipoubicaname: {
      label: 'Tipo de Ubicación',
      id: '',
      value: Object.keys(this.data).length === 0 ? '' : this.data.tipoubicaname,
    },
    tipoubicafecha_alta: {
      label: 'Fecha De Registro',
      id: '',
      value:
        Object.keys(this.data).length === 0
          ? getDate()
          : this.data.tipoubicafecha_alta.substring(0, 19),
    },
    tipoubicabaja: {
      label: 'Estado',
      id: '',
      value:
        Object.keys(this.data).length === 0
          ? 'ACTIVO'
          : this.data.tipoubicabaja,
    },
  };

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion:
        Object.keys(this.data).length === 0
          ? 'Crear Tipo de Ubicación'
          : 'Editar Tipo de Ubicación',
      visible: true,
      step: 1,
      title: 'Asignación de detalle',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  handleAdd() {
    const validate: string = (this.formFields.tipoubicaname.value as string)
      .trim()
      .replace(/\s+/g, ' ');
    if (!validate) {
      this.invalidate = true;
      this.messageError = 'El campo tipo de ubicación no puede estar vacío.';
    }
    this.addTipoUbicacion();
  }

  handlePopUp(event: any) {
    if (this.anulado) {
      this.handleClosed();
    } else {
      this.showPopUp(event);
    }
  }

  showPopUp(event: any) {
    this.dialogPopUp = !this.dialogPopUp;
    if (event) {
      this.handleClosed();
    }
  }

  handleClosed() {
    this.$emit('cerrar');
    this.dialogPopUp = false;
  }

  mounted() {
    this.handleOptions();
  }

  validateTipoubicaName() {
    const validate: string = (this.formFields.tipoubicaname.value as string)
      .trim()
      .replace(/\s+/g, ' ');
    if (!validate) {
      this.invalidate = true;
      this.messageError = 'El campo tipo de ubicación no puede estar vacío.';
    } else {
      this.invalidate = false;
      this.messageError = '';
    }
  }

  async handleOptions() {
    this.listaUsersSave = await this.getUsuariosUbicacion();
    this.listaUsers = await this.getUsers();
    this.previousList = [...this.listaUsersSave];
    this.listaUsersSave = this.listaUsersSave.map((item: any) => String(item));
  }

  async getUsers() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorTipoUbicacion({}, 'api_tipo_ubicacion/get_usuarios')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          return [];
        }
        self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getUsuariosUbicacion() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorTipoUbicacion(
      {
        tipoubicaid: Number(this.data.tipoubicaid),
      },
      'api_tipo_ubicacion/get_usuarios_ubicacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async addTipoUbicacion() {
    let self = this;
    this.loadingService.showLoading();
    const requestData: any = {
      tipoubicaname: this.formFields.tipoubicaname.value
        .toString()
        .toUpperCase(),
    };

    if (Object.keys(this.data).length !== 0) {
      requestData.tipoubicaid = Number(this.data.tipoubicaid);
      requestData.usuarioid_modifica = getUserID();
      requestData.usuariorut_modifica = localStorage.getItem('clienteDefecto');
      requestData.tipoubicabaja =
        this.formFields.tipoubicabaja.value === 'INACTIVO';
      requestData.previous_data = this.data;
    } else {
      requestData.usuariorut_alta = localStorage.getItem('clienteDefecto');
      requestData.usuarioid_alta = getUserID();
    }
    return fetchMantenedorTipoUbicacion(
      requestData,
      'api_tipo_ubicacion/add_ubicacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '2') {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return;
        }
        if (data.data.MENSAJE_RESPUESTA !== '') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.editUsersId();
          this.handleClosed();
        } else {
          this.editUsersId();
          this.handleClosed();
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        return null;
      });
  }

  async editUsersId() {
    let self = this;
    let listUsersInt: number[] = [];
    if (this.listaUsersSave.length !== 0) {
      listUsersInt = this.listaUsersSave.map((items: string) =>
        parseInt(items)
      );
    }
    this.loadingService.showLoading();
    return fetchMantenedorTipoUbicacion(
      {
        tipoubicaid: Number(this.data.tipoubicaid),
        tipoubicaname: this.formFields.tipoubicaname.value,
        usuarioid_modifica: getUserID(),
        usuariorut_modifica: localStorage.getItem('clienteDefecto'),
        usuarioid: listUsersInt,
        previous_list: this.previousList,
      },
      'api_tipo_ubicacion/edit_users_id'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '2') {
          return;
        }
        if (data.data.MENSAJE_RESPUESTA !== '') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
        this.listaUsersSave = [];
      });
  }
}
